import {UI} from "../../../../../../stem-core/ui/UIBase";
import {BasePanelPage} from "../../../../PanelPage";
import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input";
import {Messages} from "../../../../../Messages";
import {Flow} from "../../../../flows/Flow.js";
import {TextArea} from "../../../../../../stem-core/ui/input/Input";
import {styleRuleInherit} from "../../../../../../stem-core/decorators/Style";
import {BackButton} from "../../../../../../core/ui/LinkButton.jsx";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";

class BlinkTextAreaStyle extends BlinkInputStyle {
    @styleRuleInherit
    inputContainer = {
        height: 106,
    };

    @styleRuleInherit
    input = {
        padding: "12px 5px",
        overflow: "auto",
        resize: "none",
    };
}

export class GiftSubscriptionDetailsPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.giftDetails,
        };
    }

    render() {
        const {styleSheet} = this;
        const {beneficiaryEmailAddress, name, message} = Flow.giftSubscriptionDetails;

        return [
            <BlinkInput
                ref="emailInput"
                testId="giftEmailInput"
                label={Messages.giftEmail}
                inputAttributes={{type: "email"}}
                onChange={(beneficiaryEmailAddress) => {
                    Flow.giftSubscriptionDetails.update({beneficiaryEmailAddress});
                    this.redraw(); // TODO bind automatically better
                }}
                initialValue={beneficiaryEmailAddress}
            />,

            <BlinkInput
                ref="nameInput"
                testId="giftNameInput"
                label={Messages.giftName}
                initialValue={name}
                onChange={() => this.redraw()}
            />,

            <BlinkInput
                ref="messageInput"
                testId="giftMessageInput"
                label={Messages.giftMessage}
                styleSheet={BlinkTextAreaStyle}
                onChange={() => this.redraw()}
                initialValue={message}
                InputClass={TextArea}
            />,

            <BlinkButton
                label={Messages.continue}
                className={styleSheet.actionButton}
                disabled={this.isButtonDisabled()}
                onClick={() => this.continue()}
            />,

            <BackButton />,
        ];
    }

    continue() {
        Flow.giftSubscriptionDetails.updateAndResolve({
            beneficiaryEmailAddress: this.emailInput.getValue(),
            name: this.nameInput.getValue(),
            message: this.messageInput.getValue(),
        });
    }

    isButtonDisabled() {
        return !Flow.giftSubscriptionDetails.beneficiaryEmailAddress;
    }
}
